/**
 * @group DOM Attribute
 */
const name = 'onclick-target';

export {name as ONCLICK_TARGET};
